/**
 * @file Whether a Recompute now request is still running, so "Last computed"
 * reads "recomputing…". Consumer: `AnalyticsLastComputedText`. A request runs
 * from its claim until the caller's own home summary is rewritten, since the
 * analytics service rewrites that summary at the end of every cycle; a failed
 * or unstarted request never runs. Without a summary nothing reads as
 * running, so a caller the cycle writes no summary for is never stuck on it.
 */
import type { AnalyticsRecompute } from '#types';

const RUNNING: readonly AnalyticsRecompute['status'][] = [
  'requested',
  'started',
];

export const analyticsRecomputing = (
  recompute: Pick<AnalyticsRecompute, 'status' | 'requestedAt'> | undefined,
  summaryComputedAt: string | undefined,
): boolean =>
  recompute !== undefined &&
  summaryComputedAt !== undefined &&
  RUNNING.includes(recompute.status) &&
  Date.parse(recompute.requestedAt) > Date.parse(summaryComputedAt);
